import { Component } from '@angular/core';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent {
  userUuid:any
  userType:any
settingJson:any
menu:any="20px";
  searchTerm: any;
  filteredMenu: any;
  constructor(private SettingsService:SettingsService,private router:Router,private UserInfoService:UserInfoService, private userPrivileges: UserPrivilegeService,
    ){

      this.userPrivileges.userPrivilegesByModule('Admin-Mode').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });
    this.userType=this.UserInfoService.getUserType()
    this.userUuid=this.UserInfoService.getUserUuid()
    this.userType=this.userType.toUpperCase()
   this.SettingsService.settingJson().then((data:any) => {
      this.settingJson=data["menu"]
      // console.log(this.settingJson)
        // if(this.userType==="STAFF"){
          this.filteredMenu = this.settingJson;


        // }else{



        //   this.settingJson=[
        //     {
        //         "icon": "manage_accounts",
        //         "menu": "Users & Control",
        //         "subMenu": [
        //             "Users",
        //             "Roles & Permission",
        //             "Department",
        //             "Policies"
        //         ]
        //     },
        //     {
        //         "icon": "perm_data_setting",
        //         "menu": "Product Configuaration",
        //         "subMenu": [
        //             "Air Config"
        //         ]
        //     },
        //     {
        //         "icon": "settings",
        //         "menu": "Product Management",
        //         "subMenu": [
                  
        //             "Commercials"
        //         ]
        //     },
        //     {
        //       "icon":"assessment",
        //       "menu":"Reporting Config",
        //       "subMenu":["Reporting Configuration"]
            
        //     }
        // ]





        
        // this.filteredMenu = this.settingJson;

        // }

     })
     .catch((error:any) => {
     });


    

  }

  privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

  filterSubMenus = (data:any, label:any) => {
    console.log(label)
    // Create a set of valid sub menu labels
    const validLabels = new Set(label[0].children.map((child:any) => child.label));
    
  
    // Filter each menu's subMenu based on the valid labels
    return data.map((menu:any) => {
        return {
            ...menu,
            subMenu: menu.subMenu.filter((sub:any) => validLabels.has(sub))
        };
    }) .filter((menu:any) => menu.subMenu.length > 0);
  };
  
  OnClickLink(subMenu:any){
    if(subMenu==="Users"){
    this.router.navigate(["/app/"+subMenu]);}
    else if(subMenu==="Roles & Permission"){
      
      this.router.navigate(["/app/Role"]);

    }else if(subMenu==="Business Roles & Permission"){
      this.router.navigate(["/app/traveller-Role"]);
    }
    else if(subMenu==="Air"){
      
      this.router.navigate(["/app/Air-Management"]);

    }else if(subMenu==="Hotel"){
      this.router.navigate(["/app/Hotel-Management"]);

    }
    else if(subMenu==="Air Config"){
      
      if( this.userType==="STAFF"){
        this.router.navigate(["/app/Air-config"], { queryParams: { id: this.SettingsService.transform('airConfigNull') } });

      }else{
      this.router.navigate(["/app/Air-config"], { queryParams: { id: this.SettingsService.transform(this.userUuid) } });

      }


    }
    else if(subMenu==="Hotel Config"){
      
      if( this.userType==="STAFF"){
        this.router.navigate(["/app/Hotel-config"], { queryParams: { id: this.SettingsService.transform('hotelConfigNull') } });

      }else{
      this.router.navigate(["/app/Hotel-config"], { queryParams: { id: this.SettingsService.transform(this.userUuid) } });

      }


    }
    else if(subMenu==="Payment Config"){

      if( this.userType==="STAFF"){
        this.router.navigate(["/app/payment-config"], { queryParams: { id: this.SettingsService.transform('paymentConfigNull'), type: this.SettingsService.transform('lockType')  } });

      }else{
        
      this.router.navigate(["/app/payment-config"], { queryParams: { id: this.SettingsService.transform(this.userUuid), type: this.SettingsService.transform('lockType') } });

      }
      

    }
    else if(subMenu==="Data Security"){
      
      this.router.navigate(["/app/data-security"]);

    }else if(subMenu==="Commercials"){

      if(this.userType==="STAFF"){
        this.router.navigate(["/app/commercials"], { queryParams: { id: this.SettingsService.transform('commercialsNull') } });

      }else{
      this.router.navigate(["/app/commercials"], { queryParams: { id: this.SettingsService.transform(this.userUuid) } });

      }
    }
    else if(subMenu==="Reporting Configuration"){

      if( this.userType==="STAFF"){
        this.router.navigate(["/app/reporting-config"], { queryParams: { id: this.SettingsService.transform('reportingConfigNull') }});

      }else{
      this.router.navigate(["/app/reporting-config"], { queryParams: { id: this.SettingsService.transform(this.userUuid) } });

      }
    }else if(subMenu==='Travel Policy'){
      if(this.userType==="CORPORATE"){
        // this.router.navigate(["/app/Travel Policy/"+this.SettingsService.transform(this.userUuid)]);
        this.router.navigate(["/app/Travel Policy"]);

      }

    }
    else if(subMenu==='SOP'){
      if(this.userType==="CORPORATE"){
        // this.router.navigate(["/app/SOP/"+this.SettingsService.transform(this.userUuid)]);

        this.router.navigate(["/app/SOP"]);
      }

    } 
    else if(subMenu==='Business Group'){
      this.router.navigate(["/app/Business Group"]);

    }
    else if(subMenu==='Tag Config'){
      this.router.navigate(["/app/Tag-config"]);

    }
    else if(subMenu==='Content Management'){
      this.router.navigate(["/app/Notifications"]);

    }
    else if(subMenu==='Travel Policies'){
      this.router.navigate(["/app/travel_policies"]);

    }
  }

  filterMenu() {
    if (this.searchTerm) {
      const searchTermLower = this.searchTerm.toLowerCase().trim();
  
      this.filteredMenu = this.settingJson.filter((item: { menu: string; subMenu: any[]; }) =>
        item.menu.toLowerCase().includes(searchTermLower) ||
        (item.subMenu && item.subMenu.some(subMenu => subMenu.toLowerCase().includes(searchTermLower)))
      );
    } else {
      this.filteredMenu = this.settingJson;
    }
  }
  backClick(){
    this.router.navigate(["/app/flight"]);

  }
}